import {Injectable, OnDestroy} from '@angular/core';
import {SubscriptionModel} from '../entity/subscription.model';
import {SubscriptionRepository} from '../../impl/service/ngrx/subscription.repository';
import {SubscriptionDataServiceAdapter} from '../../impl/service/ngrx/subscriptionDataService.adapter';
import {AbstractFindAllService} from '../../../core/service/v2/service/findAll/abstractFindAll.service';
import {AbstractFindOneByIdService} from "../../../core/service/v2/service/findone/abstractFindOneById.service";

@Injectable()
export class SubscriptionFindOneByIdService extends AbstractFindOneByIdService<SubscriptionModel, SubscriptionModel> {

    constructor(repository: SubscriptionRepository, dataServiceAdapter: SubscriptionDataServiceAdapter) {
        super(repository, dataServiceAdapter);
    }
}
